import { useEffect, useState } from 'react'

const useDebounce = (value?: string, delay = 1000) => {
  const [debounceValue, setDebounceValue] = useState<string | undefined>(value)

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebounceValue(value)
    }, delay)

    return () => {
      clearTimeout(handler)
    }
  }, [value, delay])

  return debounceValue
}

export default useDebounce
